import { createSlice } from '@reduxjs/toolkit';
import { businessPerformanceAPI } from '../services/businessPerformaceAPI';

interface closingMonthState {
  businessPerformanceClosingMonth: string;
}

const initialState: closingMonthState = {
  businessPerformanceClosingMonth: '',
};

const closingMonthSlice = createSlice({
  name: 'businessPerformanceClosingMonth',
  initialState,
  reducers: {
    updateBusinessPerformanceClosingMonth: (state, action) => {
      state.businessPerformanceClosingMonth = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      businessPerformanceAPI.endpoints.getBusinessPerformanceSummary.matchFulfilled,
      (state, action) => {
        const closingMonth = action.payload?.body?.closingMonth;
        state.businessPerformanceClosingMonth = closingMonth
          ? `${closingMonth.slice(-2)}/${closingMonth.slice(0, 4)}`
          : '-';
      }
    );
  },
});

export const { updateBusinessPerformanceClosingMonth } = closingMonthSlice.actions;
export default closingMonthSlice.reducer;
